import { createFileRoute } from "@tanstack/react-router";
import { LibraryIcon } from "lucide-react";
import { LibraryView } from "@/components/library/library-view";
import { libraryQuery } from "@/lib/folders-api";
import { warm } from "@/lib/workspace-queries";

export const Route = createFileRoute("/_workspace/library/")({
  // A head start on the one request the page renders from.
  loader: ({ context }) => {
    warm(context.queryClient.ensureQueryData(libraryQuery));
  },
  component: LibraryPage,
});

function LibraryPage() {
  return (
    <main className="flex flex-1 flex-col p-4 md:p-6">
      <div className="mx-auto w-full max-w-6xl space-y-6">
        <div className="space-y-1">
          <p className="flex items-center gap-1.5 font-medium text-[10px] text-muted-foreground uppercase tracking-[0.25em]">
            <LibraryIcon className="size-3.5" />
            Library
          </p>
          <h1 className="font-bold text-2xl tracking-tight">Templates &amp; Policy Library</h1>
          <p className="text-muted-foreground text-sm">
            Company-level templates, handbooks and policies, kept apart from employee records.
          </p>
        </div>

        <LibraryView />
      </div>
    </main>
  );
}
